export interface ViralLoopsCampaign {
  info: {
    brandingStyle: string;
    campaignName: string;
    companyName: string;
    conversionEnabled: boolean;
    conversionUrl: string;
    isLive: boolean;
    template: string;
  };
  openModal(): void;
  identify(user: { email: string; firstname?: string; extraData?: Record<string, any> }): Promise<{
    referralCode: string;
  }>;
  getReferrer(): { referralCode: string | null; refSource: string | null };
  setReferrer(referrer: { referralCode: string; refSource?: string }): Promise<void>;
  getRank(): Promise<number>;
  getOrder(): Promise<number>;
  getUser(): Promise<unknown>;
  getPendingRewards(): Promise<unknown>;
  getGivenRewards(): Promise<unknown>;
  logout(): Promise<void>;
}

export interface ViralLoops {
  getCampaign(campaignId?: string): Promise<ViralLoopsCampaign>;
}

declare global {
  interface Window {
    ViralLoops: ViralLoops;
  }
}

export function loadViralLoops(campaignId?: string) {
  const SCRIPT_SRC = 'https://app.viral-loops.com/widgetsV2/core/loader.js';
  return new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      resolve();
    } else {
      const script = document.createElement('script');
      if (campaignId) {
        script.dataset.campaignId = campaignId;
      }
      script.src = SCRIPT_SRC;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    }
  });
}
